import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Campaign } from 'src/app/models/campaign';
import { SharedModule } from 'src/app/shared/shared.module';
import { CampaignState, LoadCampaigns } from '../../campaigns/redux';
import { LoadAllRobots, QaState } from '../redux';
import { CommonBotsComponent } from './common-bots/common-bots.component';

@Component({
  selector: 'app-qa-testing',
  templateUrl: './qa-testing.component.html',
  styleUrls: ['./qa-testing.component.css'],
  standalone: true,
  imports: [SharedModule, CommonBotsComponent]
})
export class QaTestingComponent implements OnInit, OnDestroy {
  public campaign$: Observable<any[]> = inject(Store).select(CampaignState.campaign);
  public robot$: Observable<any[]> = inject(Store).select(QaState.robots);
  public ownerRobot$: Observable<any[]> = inject(Store).select(QaState.ownerRobots);
  private unsubscribe = new Subject<void>();

  public spin;
  public formRobotData;
  public campaigns: Campaign[];

  constructor(private store: Store) {
    if (!this.store.selectSnapshot(CampaignState.campaign)) {
      this.store.dispatch(LoadCampaigns);
    }
    if (this.store.selectSnapshot(QaState.robots).length < 1) {
      this.store.dispatch(LoadAllRobots);
    }
  }

  public ngOnInit() {
    this.robot$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.formRobotData = data));
    this.campaign$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.campaigns = data));
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
